import { Identifier } from "../models";
import { IFileValidator, IListValidator, ITextValidator } from "../models/validator";

export class RequiredValidator implements ITextValidator {
  validate(value?: string): string | undefined {
    if (!value?.length) return "Dit veld mag niet leeg zijn.";
  }
}

export class RequiredListValidator implements IListValidator {
  publicatieBestemming: string | undefined = undefined;
  validate(value?: any[], opties?: Identifier[], veld?: string): string | undefined {
    if (!value?.length) return "Maak een keuze uit de lijst.";
    if (
      value &&
      opties &&
      !value.every((selectedOptie: Identifier) => opties.find((optie: Identifier) => optie.id === selectedOptie.id))
    )
      return `Kies een andere ${veld ?? "optie"}. De gekozen ${veld ?? "optie"} is niet beschikbaar voor publicatie${
        this.publicatieBestemming ? ` op ${this.publicatieBestemming}.` : "."
      }`;
  }
}

export class RequiredFileValidator implements IFileValidator {
  validate(file?: File): string | undefined {
    if (!file?.name) return "Selecteer een bestand.";
  }
}
